<template>
  <div>
    <input v-show="false" id="file_1234" type="file"  @change="loadTextFromFile" />
    <v-btn icon @click.prevent="upload()">
          <v-icon>fas fa-file-upload</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  methods: {
    loadTextFromFile(ev) {
      if (window.File && window.FileReader && window.FileList && window.Blob) {
        const file = ev.target.files[0];
        const reader = new FileReader();

        reader.onload = e => this.$emit("load", e.target.result);
        reader.readAsText(file);
      } else {
        alert("The File APIs are not fully supported in this browser.");
      }
    },
    upload(){
          document.getElementById('file_1234').click()
    }
  }
};
</script>